module.exports = [
    {
        label: 'Monitor Pedidos',
        path: '/orders-monitor-submenu',
        regex: /\/orders-monitor|room-management\/?[a-zA-Z1-9]*/,
        icon: 'layers',
        permissions: ['orders-monitor:view'],
        children: [
            {
                label: 'Resumen de Tiendas',
                path: '/orders-monitor',
                regex: /\/*orders-monitor\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['orders-monitor:view']
            },
            {
                label: 'Gestión Sala',
                path: '/room-management',
                regex: /\/*room-management\/?[a-zA-Z1-9]*/,
                permissions: ['room-management-page:view']
            }
        ]
    },
    {
        label: 'Pedidos',
        path: '/orders',
        regex: /\/*orders\/?[a-zA-Z1-9]*/,
        icon: 'cart',
        permissions: ['orders-page:view']
    },
    // {
    // label: 'Monitor pedidos',
    // path: '/resume',
    // regex: /\/resume\/?[a-zA-Z1-9]*/,
    // icon: 'layers',
    // permissions: []
    // },
    // {
    //   label: 'Monitor de Agendamiento',
    //   path: '/scheduling',
    //   regex: /\/scheduling\/?[a-zA-Z1-9]*/,
    //   icon: 'calendar'
    // },
    {
        regex: /\/dashboard-ja\/?[a-zA-Z1-9]*/,
        component: 'PendingPickingMenuItem',
        path: '/dashboard-ja',
        permissions: ['orders-pending-page:view'],
        icon: 'pie-chart'
    },
    {
        label: 'Monitor de Auditorías',
        path: '/audit-monitor',
        regex: /\/audit-monitor\/?[a-zA-Z1-9]*/,
        icon: 'clipboard',
        component: 'PendingAuditMenuItem',
        permissions: ['audit-monitor:view']
    },
    {
        label: 'Monitor de Facturados con Error',
        path: '/invoicing-monitor',
        regex: /\/invoicing-monitor\/?[a-zA-Z1-9]*/,
        icon: 'circle-exclam',
        component: 'InvoicingMenuItem',
        permissions: ['invoicing-monitor:view']
    },
    {
        label: 'Monitor de Shoppers',
        path: '/pickers-monitor',
        regex: /\/pickers-monitor\/?[a-zA-Z1-9]*/,
        icon: 'shopper',
        permissions: ['pickers-monitor:view']

    },
    {
        label: 'Gestión Split Order',
        path: '/split-order',
        regex: /\/split-order\/?[a-zA-Z1-9]*/,
        icon: 'cart',
        permissions: ['split-order-page:view']
    },
    {
        label: 'Darkstore',
        path: 'darkstore',
        regex: /\darkstore\/?[a-zA-Z1-9]*/,
        icon: 'darkstore',
        permissions: ['categories-page:view', 'darkstore-page:view', 'maintainer-darkstore-page:view'],
        children: [
            {
                label: 'Ubicación en sala',
                path: '/categories',
                regex: /\/*categories\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['categories-page:view']
            },
            {
                label: 'Ubicación en DarkStore',
                path: '/positions',
                regex: /\/*positions\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['darkstore-page:view']
            },
            {
                label: 'Mantenedor DarkStore',
                path: '/positions-maintainer-darkstore',
                regex: /\/*positions-maintainer-darkstore\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['maintainer-darkstore-page:view']
            }
        ]

    },
    {
        label: 'Gestión de Usuarios',
        path: '/users-submenu',
        regex: /\/*users|profiles\/?[a-zA-Z1-9]*/,
        icon: 'users',
        permissions: ['users-page:view', 'profiles-page:view', 'shoppers-page:view'],
        children: [
            {
                label: 'ABM Shoppers',
                path: '/shoppers',
                regex: /\/*users\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['shoppers-page:view']
            },
            {
                label: 'ABM Operacional',
                path: '/oper-users',
                regex: /\/*oper-users\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['oper-users-page:view']
            },
            {
                label: 'Usuarios - Asignar sala',
                path: '/user-salesChannels',
                regex: /\/*user-salesChannels\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['user-salesChannels-page:view']
            },
            {
                label: 'Usuarios',
                path: '/users',
                regex: /\/*users\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['users-page:view']
            },
            {
                label: 'Perfiles',
                path: '/profiles',
                regex: /\/*profiles\/?[a-zA-Z1-9]*/,
                permissions: ['profiles-page:view']
            },
            {
                label: 'Permisos',
                path: '/permissions',
                regex: /\/*permissions\/?[a-zA-Z1-9]*/,
                permissions: ['permissions-page:view']
            }
        ]
    },
    {
        label: 'Configuraciones',
        path: '/configs-submenu',
        regex: /\/*configs\/?[a-zA-Z1-9]*/,
        icon: 'gear',
        permissions: ['sc-settings:view', 'addressees-notifications-page:view', 'blacklist-page:view'],
        children: [
            {
                label: 'Configuración de Sala',
                path: '/sc-settings',
                regex: /\/*sc-settings\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['sc-settings:view']
            },
            {
                label: 'Configuración global de Sala',
                path: '/sc-global-settings',
                regex: /\/*sc-global-settings\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['sc-global-settings-page:view']
            },
            {
                label: 'Mantenedor de factores externos',
                path: '/external-factors',
                regex: /\/*external-factors\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['external-factors-page:view']
            },
            {
                label: '% de Sustitución',
                path: '/substitutions',
                regex: /\/*substitutions\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['sustitutions-page:view']
            },
            {
                label: 'Notificaciones destinatarios',
                path: '/addressees-notifications',
                regex: /\/*addressees-notifications\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['addressees-notifications-page:view']
            },
            {
                label: 'Notificaciones reportes',
                path: '/addressees-notifications-reports',
                regex: /\/*addressees-notifications-reports\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['addressees-notifications-report-page:view']
            },
            {
                label: 'Blacklist',
                path: '/blacklist',
                regex: /\/*blacklist\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: ['blacklist-page:view']
            }
        ]
    },
    {
        label: 'Centro de Ayuda',
        path: '/help-center-submenu',
        regex: /\/*help-center\/?[a-zA-Z1-9]*/,
        icon: 'help-circle',
        permissions: ['help-center-page:view'],
        children: [
            {
                label: 'Shopper',
                path: '/shopper-submenu',
                regex: /\/*shopper-submenu\/?[a-zA-Z1-9]*/,
                icon: '',
                permissions: [],
                children: [
                    {
                        label: 'Notificaciones',
                        path: '/shopper-notifications',
                        regex: /\/*notifications\/?[a-zA-Z1-9]*/,
                        icon: '',
                        permissions: []
                    },
                    {
                        label: 'Encuestas',
                        path: '/polls',
                        regex: /\/*polls\/?[a-zA-Z1-9]*/,
                        icon: '',
                        permissions: ['polls-page:view']
                    },
                    {
                        label: 'Capacitación',
                        path: '/shopper-training',
                        regex: /\/*shopper-training\/?[a-zA-Z1-9]*/,
                        icon: '',
                        permissions: ['polls-page:view']
                    },
                    {
                        label: 'App logs',
                        path: '/shopper-app-logs',
                        regex: /\/*shopper-app-logs\/?[a-zA-Z1-9]*/,
                        icon: '',
                        permissions: []
                    }
                ]
            }
        ]
    },
    {
        label: 'Formulario de Shoppers',
        path: '/shoppers-form',
        regex: /\/*shoppers-form\/?[a-zA-Z1-9]*/,
        icon: 'clipboard',
        permissions: ['shoppers-form-page:view']
    }
    // {
    //     label: 'Salir',
    //     path: '/logout',
    //     regex: /\/*logout\/?[a-zA-Z1-9]*/,
    //     icon: 'logout',
    //     component: 'LogoutMenuItem'
    // }
    // {
    //   label: 'Usuarios',
    //   path: '/customers',
    //   regex: /\/*customers\/?[a-zA-Z1-9]*/,
    //   icon: 'user'
    // }
];
